module.exports = __webpack_public_path__ + "img/Letra.8a99c82f.png";